<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-if="!$store.state.teacherAccess"
          color="green"
          class="ml-1"
          rounded
          size="28"
          v-bind="attrs"
          v-on="on"
          style="cursor: pointer"
          @click="goTo('academyStudentList')"
        >
          <v-icon dark>
            mdi-account-group-outline
          </v-icon>
        </v-avatar>
      </template>
      <span>{{ $t('eventStudent', {name: $store.state.studentLabel}) }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-if="!$store.state.teacherAccess"
          color="primary"
          rounded
          class="ml-1"
          size="28"
          v-bind="attrs"
          v-on="on"
          style="cursor: pointer"
          @click="goTo('recieve')"
        >
          <v-icon dark>
            mdi-credit-card-multiple-outline
          </v-icon>
        </v-avatar>
      </template>
      <span>{{ $t('cashReceive') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-if="!$store.state.teacherAccess"
          color="amber"
          class="ml-1"
          rounded
          size="28"
          v-bind="attrs"
          v-on="on"
          style="cursor: pointer"
          @click="goTo('academyEventList')"
        >
          <v-icon color="brown">
            mdi-school-outline
          </v-icon>
        </v-avatar>
      </template>
      <span>{{ $t('academyEventList') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-if="!$store.state.teacherAccess"
          color="blue"
          rounded
          class="ml-1"
          size="28"
          v-bind="attrs"
          v-on="on"
          style="cursor: pointer"
          @click="goTo('academySessionList')"
        >
          <v-icon dark>
            mdi-calendar-text-outline
          </v-icon>
        </v-avatar>
      </template>
      <span>{{ $t('academySessionList') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-if="!$store.state.teacherAccess"
          color="pink"
          class="ml-1"
          rounded
          size="28"
          v-bind="attrs"
          v-on="on"
          style="cursor: pointer"
          @click="goTo('cost')"
        >
          <v-icon dark>
            mdi-account-cash-outline
          </v-icon>
        </v-avatar>
      </template>
      <span>{{ $t('cost') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-if="$store.state.teacherAccess"
          color="pink"
          class="ml-1"
          rounded
          size="28"
          v-bind="attrs"
          v-on="on"
          style="cursor: pointer"
          @click="turnover()"
        >
          <v-icon dark>
            mdi-recycle-variant
          </v-icon>
        </v-avatar>
      </template>
      <span>{{ $t('turnover') }}</span>
    </v-tooltip>
    <v-btn
      v-if="$store.state.teacherAccess && remain && remain !== 0"
      outlined
      color="primary"
      small
      @click="accountRemain"
    >
      {{ $t('remain') }} : {{$numberFormat(remain)}} {{(remain > 0 ? $t('debtor') : $t('creditor'))}}
      <v-icon
        right
        dark
      >
        mdi-keyboard_return
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
  import General from '../../../../../Mixins/general'
  export default {
    name: 'shortcut',
    mixins: [General],
    data: () => ({
      remain: null,
      loading: false,
    }),
    mounted () {
      if (this.$store.state.teacherAccess) {
        this.accountRemain()
      }
    },
    methods: {
      turnover () {
        this.$router.push({ name: 'turnover', params: { selfProp: 'active' } })
      },
      accountRemain () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'getdetail', {
          params: {
            select: 'accountRemain',
          },
        })
          .then(res => {
            res = res.data
            if (res.remain) {
              app.remain = res.remain.remain
            }
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
